import React from 'react';
import { FootCont, FootFinal, LogoSvg, FinalLeft, FinalRight } from './styles';
import { Full, Paragraph } from '../../theming/styles';
import { Link } from 'react-router-dom';

const Foot = () => {
    return (
        <FootCont>
            <Full>
                <FootFinal>
                    <FinalLeft>
                        <Link to='/'>
                            <LogoSvg
                                width='45'
                                height='45'
                                viewBox='0 0 45 45'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d="M12.041 3.60352V10.459H28.7402V3.60352H26.1035V7.82227H24.5215V6.41602H23.291V7.82227H21.709V3.60352H19.0723V7.82227H17.4902V6.41602H16.2598V7.82227H14.6777V3.60352H12.041ZM30.3223 5.29743V7.5346L34.6529 11.8652H28.916V13.4473H40.166V11.8652H36.8901L30.3223 5.29743ZM15.2909 12.041L17.1287 16.084H24.1112L26.6839 12.041H15.2909ZM14.3885 13.879L13.9875 16.084H15.3907L14.3884 13.879H14.3885ZM27.3339 13.9665L25.9864 16.084H27.334V13.9665H27.3339ZM13.7 17.666L12.9649 21.709H17.9477L16.1099 17.666H13.7ZM17.8478 17.666L19.6856 21.709H20.5316L23.1044 17.666H17.8478ZM24.9797 17.666L22.4069 21.709H27.334V17.666H24.9797ZM12.6773 23.291L11.9421 27.334H16.9521L19.0244 24.0776L18.6668 23.291H12.6773ZM21.4001 23.291L20.8194 24.2036L22.2422 27.334H27.334V23.291H21.4001ZM19.8058 25.7966L18.8276 27.334H20.5045L19.8058 25.7966ZM11.6546 28.916L10.9195 32.959H13.3724L15.9453 28.916H11.6546ZM17.8207 28.916L15.2478 32.959H23.0613L21.2237 28.916H17.8207ZM22.9614 28.916L24.799 32.959H27.334V28.916H22.9614ZM10.6319 34.541L10.0799 37.5779C10.1684 37.6236 10.2551 37.6728 10.3394 37.7256L12.3657 34.541H10.6319ZM14.2412 34.541L11.4867 38.8695C11.8371 39.4247 12.041 40.0803 12.041 40.7812C12.041 40.991 12.0219 41.1963 11.987 41.3965H14.0429C14.0081 41.1963 13.9888 40.991 13.9888 40.7812C13.9888 38.8005 15.6116 37.1777 17.5924 37.1777C19.5732 37.1777 21.1959 38.8005 21.1959 40.7812C21.1959 40.991 21.1767 41.1963 21.1418 41.3965H23.1693C23.1344 41.1963 23.1152 40.991 23.1152 40.7812C23.1152 39.3638 23.9463 38.13 25.1448 37.5427L23.7804 34.541H14.2412ZM25.5184 34.541L26.7169 37.1777H26.7187C26.9284 37.1777 27.1337 37.1969 27.3339 37.2318V34.541H25.5183H25.5184ZM8.4375 38.7598C7.31162 38.7598 6.41602 39.6554 6.41602 40.7812C6.41602 41.9071 7.31162 42.8027 8.4375 42.8027C9.56338 42.8027 10.459 41.9071 10.459 40.7812C10.459 39.6554 9.56338 38.7598 8.4375 38.7598ZM17.5924 38.7598C16.4665 38.7598 15.5709 39.6554 15.5709 40.7812C15.5709 41.9071 16.4665 42.8027 17.5924 42.8027C18.7182 42.8027 19.6138 41.9071 19.6138 40.7812C19.6138 39.6554 18.7182 38.7598 17.5924 38.7598ZM26.7188 38.7598C25.5929 38.7598 24.6973 39.6554 24.6973 40.7812C24.6973 41.9071 25.5929 42.8027 26.7188 42.8027C27.8446 42.8027 28.7402 41.9071 28.7402 40.7812C28.7402 39.6554 27.8446 38.7598 26.7188 38.7598Z"                
                                    fill="black"
                                />
                                <defs>
                                    <linearGradient id="paint0_linear_110_20" x1="24.21" y1="11.52" x2="14.3164" y2="20.0324" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="white"/>
                                        <stop offset="1"/>
                                    </linearGradient>
                                </defs>
                            </LogoSvg>
                        </Link>
                        <Paragraph style={{ fontWeight: 300 }}>
                            Designed and Built by Deven Sharma
                        </Paragraph>
                    </FinalLeft>
                    <FinalRight>
                        <a
                            href='https://www.linkedin.com/in/deven-sharma-78274955/'
                        >
                            <Paragraph style={{ fontWeight: 300 }}>
                                LinkedIn
                            </Paragraph>
                        </a>
                        <a href='mailto: deven.sharma@gmail.com'>
                            <Paragraph style={{ fontWeight: 300 }}>
                                Email
                            </Paragraph>
                        </a>
                    </FinalRight>
                </FootFinal>
            </Full>
        </FootCont>
    );
};

export { Foot };
